import { CommonModule, DatePipe } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Renderer2,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConsultationsService } from '../../../../core/services/consultation/consultations.service';
import { FullscreenService } from '../../../../core/services/fullscreen.service';
import {
  FormsModule,
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  FormArray,
  FormControl,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { PatientsService } from '../../../../core/services/patient/patients.service';
import { StatusUtils } from '../../../../utils/status-utils';
import { CaseStatus } from '../../../../../enums/case-status.enum';
import { SignalRService } from '../../../../core/services/signalR/signalR';
import { environment } from '../../../../../environments/environment';
import { FullscreenOverlayComponent } from '../../../components/fullscreen-overlay/fullscreen-overlay.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { lettersOnlyValidator } from '../../../shared/validators/validators';
import { UserSessionModel } from '../../../../core/models/user/current-user.model';
import { GenderUtils } from '../../../../utils/gender-utils';
import { SkinTypes } from '../../../../../enums/skin-types.enum';
import { ToastService } from '../../../../core/services/toast.service';
import { dateFormatValidator } from '../../../validators/birth-date-validator.validator';
import { InputValidationService } from '../../../../core/services/input-validation.service';
import { FormatBirthDateService } from '../../../../core/services/format-birth-date.service';
interface SkinTypeModel {
  id: number;
  name: string;
  desc: string;
}

@Component({
  selector: 'app-patient-case-card',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FullscreenOverlayComponent,
    TranslateModule,
    SelectDropDownModule,
  ],
  templateUrl: './patient-case-card.component.html',
  styleUrl: './patient-case-card.component.scss',
  providers: [DatePipe],
})
export class PatientCaseCardComponent implements AfterViewInit {
  @ViewChild('waitingModalModal') waitingModalModal!: ElementRef;
  @ViewChild('nameLastnameBirthDateValidationErrorModal')
  nameLastnameBirthDateValidationErrorModal!: ElementRef;
  private backdropElement: HTMLElement | null = null;
  private subscriptions: Subscription = new Subscription();
  caseStatus = CaseStatus;
  saveAndTakeCaseForm: FormGroup;
  patientInformationForm: FormGroup;
  lesionCharacteristicsForm: FormGroup;
  caseId: string = '';
  paitentIdByRelatedCase: string = '';
  patientId: string = '';
  caseDetailHeader = {
    name: '',
    lastName: '',
    pidNo: '',
    gender: '',
    age: null,
    birthDate: '',
    patientStatus: 0,
    createdDate: '',
    createdBy: '',
    caseId: '',
    customerCode: '',
    bodyLocation: '',
    selectedDateTime: '',
  };
  caseImages: any = [];
  predispositions: any = [];
  complaints: any = [];
  otherComplaints: any = [];
  medications: any = [];
  otherSymptoms: any = [];
  locationX: number | null = null;
  locationY: number | null = null;
  selectedImage: any = null;
  isOverlayLoading: boolean = false;
  caseTimelineList: any = [];
  selectedIndex: number = 0;
  today: number = Date.now();
  isCaseToday: string = '';
  takeImageAgainBtn: boolean = true;
  isFormElementsEnabled: boolean = false;
  private tabChangeListener: any;
  selectedTimelineCaseId: string = '';
  statusClass: string;
  statusText: string;
  private interval: any;
  isAppointmentPatient: boolean = false;
  appointmentId: string = '';
  workListPatientId: string = '';
  patientInformationObject: any = null;
  medicalHistoryArr: any = null;
  selectedRiskFactors: string[] = [];
  selectedDermatologicDiseases: string[] = [];
  selectedNeoplasticDiseases: string[] = [];
  selectedDiseasesCausingImmunosuppression: string[] = [];
  selectedOtherDiseases: string[] = [];
  selectedMedications: string[] = [];
  skinTypes: SkinTypeModel[];
  skinTypeColors: string[] = [
    '#F3D0B0',
    '#E7B48F',
    '#D29E7D',
    '#BA7750',
    '#7A431E',
    '#3C211D',
  ];
  showSaveAndTakePicture: boolean = true;
  isCustomCongenitalChecked: boolean = false;
  currentUser: UserSessionModel | null = null;
  maxDate: string;
  genders = GenderUtils?.getAllGenders();
  showSaveAndTakePictureButton: boolean = true;
  patientCaseCardInformation: any = null;
  lightColoredEyes: boolean = false;
  redHair: boolean = false;
  freckles: boolean = false;
  selectedChangeItems: string[] = [];
  qrCodeDetails: { url: string };

  @ViewChild('viewer') viewerElement!: ElementRef;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private consultationsService: ConsultationsService,
    private patientsService: PatientsService,
    private fullscreenService: FullscreenService,
    private fb: FormBuilder,
    private signalRService: SignalRService,
    private renderer2: Renderer2,
    private translate: TranslateService,
    private toastService: ToastService,
    private inputValidationService: InputValidationService,
    private formatBirthDateService: FormatBirthDateService
  ) {
    const userLang = localStorage.getItem('selectedLanguage') || 'en';
    this.translate.use(userLang);
    this.setSkinTypesDescriptions();
    const today = new Date();
    this.maxDate = today.toISOString().split('T')[0];
    // this.createPatientImageConnection();
    this.saveAndTakeCaseForm = this.fb.group({
      complaints: [[], Validators.required],
      predispositions: [[], Validators.required],
      otherSymptoms: [[], Validators.required],
      medications: [[], Validators.required],
      otherHealthInformation: ['', Validators.required],
      lesionChanges: this.fb.array([]),
      diameterGrowthChanges: this.fb.array([]),
      additionalInformation: ['', Validators.required],
      durationOfDisease: [
        '',
        [Validators.required, Validators.pattern(/^\d[\s\S]*$/)],
      ],
      hasWound: [false],
      hasBleeding: [false],
      isCongenital: [false],
    });
    this.patientInformationForm = this.fb.group({
      name: ['', [Validators.required, lettersOnlyValidator()]],
      lastName: ['', [Validators.required, lettersOnlyValidator()]],
      birthDate: ['', [Validators.required, dateFormatValidator()]],
      gender: [null, Validators.required],
      height: [null, [Validators.required, Validators.max(300)]],
      weight: [null, [Validators.required, Validators.max(999)]],
      phone1: [
        '',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(15),
          Validators.pattern('^\\+?[0-9]{7,15}$'),
        ],
        ,
      ],
      email: ['', [Validators.required, Validators.email]],
      generalAppearances: this.fb.group({}),
      skinType: [null, Validators.required],
    });
    this.lesionCharacteristicsForm = this.fb.group({
      customCongenitalValue: [1, [Validators.min(1)]],
      customCongenitalUnit: [this.translate.instant('weeks')],
      complaints: this.fb.array([]),
      since: this.fb.array([]),
      change: this.fb.array([]),
    });
  }

  async ngOnInit() {
    this.subscriptions.add(
      this.translate.onLangChange.subscribe(() => {
        this.genders = GenderUtils?.getAllGenders();
        this.setSkinTypesDescriptions();
      })
    );

    await StatusUtils?.initializeTranslateService(this.translate);
    await GenderUtils?.initializeTranslateService(this.translate);
    this.genders = GenderUtils?.getAllGenders();
    this.getMedicalInformations();
    const currentRoutePath = this.route.snapshot.routeConfig?.path;

    // Create new case
    if (currentRoutePath.split('/')[0] === 'new-patient-case-card') {
      this.goToOtherTab('medications');
      this.route.paramMap.subscribe((params) => {
        this.patientId = params.get('id') || '';
        if (this.patientId) {
          this.getPatientDetail(this.patientId);
          this.getPatientCaseCardInformation(this.patientId);
        }
      });
    }

    // Add related case
    if (currentRoutePath.split('/')[0] === 'add-patient-case-card') {
      this.goToOtherTab('medications');
      this.route.params.subscribe((params) => {
        this.patientId = params['patientId'];
        this.caseId = params['caseId'];
        if (this.caseId) {
          this.getPatientCaseCardInformation(this.patientId);
          this.getConsultationDetail(this.caseId, 'detail');
          this.getCaseTimeLineList(this.caseId);
        }
      });
    }

    // Create new case from appointment
    if (
      currentRoutePath.split('/')[0] === 'new-patient-case-card-appointment'
    ) {
      this.goToOtherTab('medications');
      this.route.paramMap.subscribe((params) => {
        this.patientId = params.get('id') || '';
        this.appointmentId = params.get('appointmentId') || '';
        if (this.patientId) {
          this.getPatientDetail(this.patientId);
          this.getPatientCaseCardInformation(this.patientId);
          if (this.appointmentId) {
            this.isAppointmentPatient = true;
            if (this.patientId) {
              this.getAppointmentCase(this.patientId);
            }
          }
        }
      });
    }

    // Add related case from appointment
    if (
      currentRoutePath.split('/')[0] === 'add-patient-case-card-appointment'
    ) {
      this.goToOtherTab('medications');
      this.route.params.subscribe((params) => {
        this.patientId = params['patientId'];
        this.caseId = params['caseId'];
        this.appointmentId = params['appointmentId'] || '';
        if (this.caseId) {
          this.getPatientCaseCardInformation(this.patientId);
          this.getConsultationDetail(this.caseId, 'detail');
          this.getCaseTimeLineList(this.caseId);
          if (this.appointmentId) {
            this.isAppointmentPatient = true;
            if (this.patientId) {
              this.getAppointmentCase(this.patientId);
            }
          }
        }
      });
    }

    // Come from work list
    if (currentRoutePath.split('/')[0] === 'appointment-detail') {
      this.goToOtherTab('patient-information-content');
      this.route.paramMap.subscribe((params) => {
        const newPatientId = params.get('id') || '';
        this.appointmentId = params.get('id') || '';
        this.isAppointmentPatient = true;
        if (newPatientId) {
          this.getAppointmentCase(newPatientId);
        }
      });
    }
  }

  ngAfterViewInit() {
    this.fullscreenService.initializeFullscreenButtons();
    this.tabChangeListener = this.handleTabChange.bind(this);
    document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tab) => {
      tab.addEventListener('shown.bs.tab', this.tabChangeListener);
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tab) => {
      tab.removeEventListener('shown.bs.tab', this.tabChangeListener);
    });
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  createPatientRecordWithQrCode(caseId: string) {
    this.patientsService.createPatientRecordWithQrCode(caseId).subscribe({
      next: (res) => {
        const blob = new Blob([res], { type: 'image/png' });
        const url = URL.createObjectURL(blob);
        this.qrCodeDetails = { url: url };
      },
    });
  }

  setSkinTypesDescriptions() {
    const manipulateSkinTypes: SkinTypeModel[] = [
      {
        id: 1,
        name: this.translate.instant('skinTypes.pale.name'),
        desc: this.translate.instant('skinTypes.pale.desc'),
      },
      {
        id: 2,
        name: this.translate.instant('skinTypes.sensitive.name'),
        desc: this.translate.instant('skinTypes.sensitive.desc'),
      },
      {
        id: 3,
        name: this.translate.instant('skinTypes.fair.name'),
        desc: this.translate.instant('skinTypes.fair.desc'),
      },
      {
        id: 4,
        name: this.translate.instant('skinTypes.olive.name'),
        desc: this.translate.instant('skinTypes.olive.desc'),
      },
      {
        id: 5,
        name: this.translate.instant('skinTypes.dark.name'),
        desc: this.translate.instant('skinTypes.dark.desc'),
      },
      {
        id: 6,
        name: this.translate.instant('skinTypes.veryDark.name'),
        desc: this.translate.instant('skinTypes.veryDark.desc'),
      },
    ];
    this.skinTypes = manipulateSkinTypes;
  }

  protected async createPatientImageConnection() {
    const signalRBasePath = `${environment.apiLocations.patient}`.split(
      '/api/v1'
    )[0];
    const hubUrl = 'patient-hub';
    this.signalRService.connect(hubUrl, signalRBasePath);
    this.signalRService.on(hubUrl, 'receiveImageUploaded', signalRBasePath, (message) => {
      const parsedJson = JSON.parse(message);
      if (parsedJson.PatientRecordCaseId === this.caseId) {
        if (parsedJson) {
          const image = {
            src: `data:image/jpeg;base64,${parsedJson.FileData}`,
            id: `imageModal${parsedJson.PatientRecordCaseImageId}`,
            alt: `Lesion Close-up`,
            patientRecordId: parsedJson.PatientRecordCaseImageId,
            isSelected: parsedJson.IsSelected,
          };
          this.caseImages = [image, ...this.caseImages];
          this.isOverlayLoading = false;
        }
      }
    });
  }

  handleTabChange(event: Event) {
    const target = event.target as HTMLElement;
    const href = target.getAttribute('href');
    if (href === '#consultationReport') {
      this.getConsultationReport(this.caseId);
    }
  }

  getAppointmentCase(id: string): void {
    this.patientsService.appoinmentCaseDetail(id).subscribe({
      next: (res) => {
        this.caseDetailHeader.name = res.name;
        this.caseDetailHeader.lastName = res.lastName;
        this.caseDetailHeader.gender = this.getGender(res.gender);
        this.caseDetailHeader.age = this.getAge(res);
        this.caseDetailHeader.birthDate = res.birthDate;
        this.caseDetailHeader.createdDate = res.createdDate;
        this.caseDetailHeader.pidNo = res.pidNo;
        this.caseDetailHeader.customerCode = res.customerCode;
        this.caseDetailHeader.selectedDateTime = res.selectedDateTime;
        this.workListPatientId = res.patientId;

        this.patientInformationForm.patchValue({
          name: res.name,
          lastName: res.lastName,
          gender: res.gender,
          birthDate: res.birthDate ? this.formatDate2(res.birthDate) : null,
          email: res.email,
          phone1: res.mobilePhone,
        });
      },
    });
  }

  getAge(caseDetail: { age: number; birthDate: string }) {
    if (!!caseDetail?.age && +caseDetail.age > 0) return caseDetail.age;
    if (!caseDetail?.birthDate) return '';
    const date = caseDetail?.birthDate.split('T')[0];
    const birthDate = new Date(date);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const isBeforeBirthday =
      today.getMonth() < birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() &&
        today.getDate() < birthDate.getDate());

    if (isBeforeBirthday) {
      age -= 1;
    }
    return age;
  }

  getGender(gender: number): string {
    if (gender === 2) return this.translate.instant('male');
    else if (gender === 3) return this.translate.instant('female');
    return this.translate.instant('other');
  }

  getConsultationReport(id: string) {
    this.consultationsService.getReport(id).subscribe({
      next: (res) => {
        if (res?.patientRapport) {
          this.displayPdf(res.patientRapport);
        }
      },
    });
  }

  displayPdf(base64Pdf: string) {
    if (!base64Pdf) {
      const content = document.getElementById('consultationReport');
      if (content) {
        content.innerHTML = 'Consultation report is not ready yet.';
      }
      return;
    }
    const byteCharacters = atob(base64Pdf);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);
    const iframe = document.createElement('iframe');
    iframe.src = blobUrl;
    iframe.width = '100%';
    iframe.height = '600px';
    iframe.style.border = 'none';

    const content = document.getElementById('consultationReport');
    if (content) {
      content.innerHTML = '';
      content.appendChild(iframe);
      iframe.oncancel = () => {
        URL.revokeObjectURL(blobUrl);
      };
    }
  }

  getPatientDetail(id: string) {
    if (id) {
      this.patientsService.patientDeteail(id).subscribe({
        next: (res) => {
          this.caseDetailHeader.name = res.name;
          this.caseDetailHeader.lastName = res.lastName;
          this.caseDetailHeader.gender = res.gender;
          this.caseDetailHeader.age = res.age;
          this.caseDetailHeader.birthDate = res.birthDate;
          this.caseDetailHeader.createdDate = res.createdDate;
          this.caseDetailHeader.pidNo = res.pidNo;
          this.caseDetailHeader.customerCode = res.centre;
        },
      });
    }
  }

  selectedRiskFactorIds: string[] = [];
  selectedDermatologicDiseasesIds: string[] = [];
  selectedNeoplasticDiseasesIds: string[] = [];
  selectedDiseaseCousingImmunosuppressionsIds: string[] = [];
  selectedOtherDiseasesIds: string[] = [];
  selectedMedicationsIds: string[] = [];

  isCheckedRisk(id: string) {
    return this.selectedRiskFactorIds.includes(id) || this.selectedRiskFactors.includes(id);
  }

  isCheckedDermatologicDiseases(id: string) {
    return this.selectedDermatologicDiseasesIds.includes(id) || this.selectedDermatologicDiseases.includes(id);
  }

  isCheckedNeoplasticDiseases(id: string) {
    return this.selectedNeoplasticDiseasesIds.includes(id) || this.selectedNeoplasticDiseases.includes(id);
  }

  isCheckedDiseaseCousingImmunosuppressions(id: string) {
    return this.selectedDiseaseCousingImmunosuppressionsIds.includes(id) || this.selectedDiseasesCausingImmunosuppression.includes(id);
  }

  isCheckedOtherDiseases(id: string) {
    return this.selectedOtherDiseasesIds.includes(id) || this.selectedOtherDiseases.includes(id);
  }

  isCheckedMedicationsIds(id: string) {
    return this.selectedMedicationsIds.includes(id) || this.selectedMedications.includes(id);
  }

  getPatientCaseCardInformation(id: string) {
    if (id) {
      this.patientsService.patientCaseCardInformation(id).subscribe({
        next: (res) => {
          this.patientCaseCardInformation = res;
          this.patientInformationForm.patchValue({
            name: res.name,
            lastName: res.lastName,
            pidNo: res.pidNo,
            birthDate: res.birthDate ? this.formatDate2(res.birthDate) : null,
            gender: res.gender,
            email: res.email,
            height: res.height,
            weight: res.weight,
            phone1: res.phone1,
            skinType: res.dermatologyCaseInformation.skinType,
            generalAppearances:
              res.dermatologyCaseInformation.generalAppearance,
          });
          this.selectedRiskFactorIds =
            res.dermatologyCaseInformation.riskFactors.map((item) => item.id);
          this.selectedDermatologicDiseasesIds =
            res.dermatologyCaseInformation.dermatologicDiseases.map(
              (item) => item.id
            );
          this.selectedNeoplasticDiseasesIds =
            res.dermatologyCaseInformation.neoplasticDiseases.map(
              (item) => item.id
            );
          this.selectedDiseaseCousingImmunosuppressionsIds =
            res.dermatologyCaseInformation.diseaseCousingImmunosuppressions.map(
              (item) => item.id
            );
          this.selectedOtherDiseasesIds =
            res.dermatologyCaseInformation.otherDiseases.map((item) => item.id);
          this.selectedMedicationsIds = res.medications.map((item) => item.id);

          this.lightColoredEyes =
            res.dermatologyCaseInformation.generalAppearance.lightColoredEyes;
          this.redHair =
            res.dermatologyCaseInformation.generalAppearance.redHair;
          this.freckles =
            res.dermatologyCaseInformation.generalAppearance.freckles;
        },
      });
    }
  }

  getAppointmentPatientCaseCardInformation() {}

  getConsultationDetail(id: string, type: string) {
    if (id) {
      this.consultationsService
        .consultationDetailByPatientRecordCaseId(id)
        .subscribe({
          next: (res) => {
            this.caseDetailHeader.name = res.name;
            this.caseDetailHeader.lastName = res.lastName;
            this.caseDetailHeader.gender = res.gender;
            this.caseDetailHeader.age = res.age;
            this.caseDetailHeader.birthDate = res.birthDate;
            this.caseDetailHeader.createdDate = res.createdDate;
            this.caseDetailHeader.customerCode = res.customerCode;
            this.caseDetailHeader.bodyLocation = res.location;
            this.caseDetailHeader.pidNo = res.pidNo;
            this.statusClass = StatusUtils?.getCaseStatusClass(
              res?.patientStatus
            );
            this.statusText = StatusUtils?.getCaseStatusText(
              res?.patientStatus
            );
          },
        });
    }
  }

  getCaseTimeLineList(id: string) {
    if (id) {
      this.patientsService
        .consultationTimeLineListByPatientRecordCaseId(id)
        .subscribe({
          next: (res) => {
            this.caseTimelineList = res;
            this.selectItem(this.caseTimelineList.length, { isToday: true });
          },
        });
    }
  }

  getPatientRecordCaseDetail(id: string) {
    if (id) {
      this.patientsService.patientRecordCaseDetail(id).subscribe({
        next: (res) => {
          this.saveAndTakeCaseForm.patchValue({
            complaints: res.complaints,
            predispositions: res.geneticPredispositions,
            otherSymptoms: res.otherSymptoms,
            medications: res.medications,
            otherHealthInformation: res.otherHealthInformation,
            additionalInformation: res.additionalInformation,
          });

          // Lesion Changes
          const lesionChangesArray = this.saveAndTakeCaseForm.get(
            'lesionChanges'
          ) as FormArray;
          lesionChangesArray.clear();
          for (const key in res.lesionChange) {
            if (res.lesionChange.hasOwnProperty(key) && res.lesionChange[key]) {
              lesionChangesArray.push(new FormControl(key));
            }
          }

          const diameterGrowthChangesArray = this.saveAndTakeCaseForm.get(
            'diameterGrowthChanges'
          ) as FormArray;
          diameterGrowthChangesArray.clear();
          for (const key in res.diameterGrowth) {
            if (
              res.diameterGrowth.hasOwnProperty(key) &&
              res.diameterGrowth[key]
            ) {
              diameterGrowthChangesArray.push(new FormControl(key));
            }
          }
        },
      });
    }
  }

  getPatientRecordCaseImages(id: string) {
    if (id) {
      this.patientsService.patientRecordCaseImages(id).subscribe({
        next: (res) => {
          if (res.length > 0) {
            this.caseImages = res.map((image: any, index: number) => ({
              src: `data:image/jpeg;base64,${image.fileData}`,
              id: `imageModal${index + 1}`,
              alt: `Lesion Close-up ${index + 1}`,
              patientRecordId: image.id,
              isSelected: image.isSelected,
            }));
            this.closeWaitingModal();
            this.router.navigate([
              '/patient/detail',
              this.patientId || this.workListPatientId,
            ]);
          }
        },
      });
    }
  }

  getConsultationTimeLineByCaseId(id: string) {
    if (id) {
      this.patientsService.consultationTimeLineByCaseId(id).subscribe({
        next: () => {},
      });
    }
  }

  selectImage(event: MouseEvent, image: any) {
    this.selectedImage = image;
    this.selectedImage.isSelected = true;
    this.patientsService
      .updateSelectedPatientRecordCaseImage(this.selectedImage.patientRecordId)
      .subscribe({
        next: () => {},
      });
  }

  formatDate(dateString: string): string {
    const datePattern = /^\d{2}-\d{2}-\d{4}$/;

    if (!datePattern.test(dateString)) {
      return dateString;
    }

    const [day, month, year] = dateString.split('-').map(Number);

    if (month < 1 || month > 12) {
      return dateString;
    }

    const daysInMonth = new Date(year, month, 0).getDate();
    if (day < 1 || day > daysInMonth) {
      return dateString;
    }

    const date = new Date(Date.UTC(year, month - 1, day));

    return date.toISOString().split('T')[0];
  }

  getMedicalInformations() {
    this.consultationsService.medicalInformations().subscribe({
      next: (res) => {
        this.medicalHistoryArr = res;
      },
    });
  }

  isSaveAndTakeImageBtnDiasabled(): boolean {
    return this.saveAndTakeCaseForm.valid;
  }

  // Submit Form Section
  generalAppearance(event: any) {
    const formArray: FormArray = this.patientInformationForm.get(
      'generalAppearances'
    ) as FormArray;

    if (event.target.checked) {
      formArray.push(new FormControl(event.target.value));
    } else {
      const index = formArray.controls.findIndex(
        (x) => x.value === event.target.value
      );
      formArray.removeAt(index);
    }
  }

  savePatientInformationForm() {
    this.patientInformationForm.value.birthDate = this.formatDate(
      this.patientInformationForm.value.birthDate
    );

    const generalAppearancesArray = [];
    const generalAppearancesObject = {
      freckles: generalAppearancesArray?.includes('freckles') || false,
      redHair: generalAppearancesArray?.includes('redHair') || false,
      lightColoredEyes:
        generalAppearancesArray?.includes('lightColoredEyes') || false,
    };

    this.patientInformationObject = {
      ...this.patientInformationForm.value,
      gender: Number(this.patientInformationForm.value.gender),
      generalAppearance: generalAppearancesObject,
      customerCode: this.caseDetailHeader.customerCode,
    };
    delete this.patientInformationObject.generalAppearances;
  }

  generalComplaint(event: any) {
    const formArray: FormArray = this.lesionCharacteristicsForm.get(
      'complaints'
    ) as FormArray;

    if (event.target.checked) {
      formArray.push(new FormControl(event.target.value));
    } else {
      const index = formArray.controls.findIndex(
        (x) => x.value === event.target.value
      );
      formArray.removeAt(index);
    }
  }

  sinceCheckbox(event: any) {
    const formArray: FormArray = this.lesionCharacteristicsForm.get(
      'since'
    ) as FormArray;

    if (event.target.checked) {
      this.lesionCharacteristicsForm.get('customCongenitalValue')?.disable();
      this.lesionCharacteristicsForm.get('customCongenitalUnit')?.disable();
      formArray.push(new FormControl(event.target.value));
    } else {
      this.lesionCharacteristicsForm.get('customCongenitalValue')?.enable();
      this.lesionCharacteristicsForm.get('customCongenitalUnit')?.enable();
      const index = formArray.controls.findIndex(
        (x) => x.value === event.target.value
      );
      formArray.removeAt(index);
    }
  }

  changeCheckbox(event: any) {
    const formArray: FormArray = this.lesionCharacteristicsForm.get(
      'change'
    ) as FormArray;

    if (event.target.checked) {
      this.selectedChangeItems.push(event.target.value);

      formArray.push(new FormControl(event.target.value));
    } else {
      const index = formArray.controls.findIndex(
        (x) => x.value === event.target.value
      );
      if (index > -1) {
        formArray.removeAt(index);
      }

      const selectedIndex = this.selectedChangeItems.indexOf(
        event.target.value
      );
      if (selectedIndex > -1) {
        this.selectedChangeItems.splice(selectedIndex, 1);
      }
    }
  }

  onMedicalHistoryChange(event: Event, type: string): void {
    if (type === 'risk-factors') {
      const checkbox = event.target as HTMLInputElement;
      const id = checkbox.value;
      if (checkbox.checked) {
        this.selectedRiskFactors.push(id);
      } else {
        this.selectedRiskFactors = this.selectedRiskFactors.filter(
          (selectedId) => selectedId !== id
        );
        this.selectedRiskFactorIds = this.selectedRiskFactorIds.filter(
          (selectedId) => selectedId !== id
        );
      }
    } else if (type === 'dermatologic-diseases') {
      const checkbox = event.target as HTMLInputElement;
      const id = checkbox.value;
      if (checkbox.checked) {
        this.selectedDermatologicDiseases.push(id);
      } else {
        this.selectedDermatologicDiseases =
          this.selectedDermatologicDiseases.filter(
            (selectedId) => selectedId !== id
          );
        this.selectedDermatologicDiseasesIds = this.selectedDermatologicDiseasesIds.filter(
          (selectedId) => selectedId !== id
        );
      }
    } else if (type === 'neoplastic-diseases') {
      const checkbox = event.target as HTMLInputElement;
      const id = checkbox.value;
      if (checkbox.checked) {
        this.selectedNeoplasticDiseases.push(id);
      } else {
        this.selectedNeoplasticDiseases =
          this.selectedNeoplasticDiseases.filter(
            (selectedId) => selectedId !== id
          );
        this.selectedNeoplasticDiseasesIds = this.selectedNeoplasticDiseasesIds.filter(
          (selectedId) => selectedId !== id
        );
      }
    } else if (type === 'diseases-causing-immunosuppression') {
      const checkbox = event.target as HTMLInputElement;
      const id = checkbox.value;
      if (checkbox.checked) {
        this.selectedDiseasesCausingImmunosuppression.push(id);
      } else {
        this.selectedDiseasesCausingImmunosuppression =
          this.selectedDiseasesCausingImmunosuppression.filter(
            (selectedId) => selectedId !== id
          );
        this.selectedDiseaseCousingImmunosuppressionsIds = this.selectedDiseaseCousingImmunosuppressionsIds.filter(
          (selectedId) => selectedId !== id
        );
      }
    } else if (type === 'other-diseases') {
      const checkbox = event.target as HTMLInputElement;
      const id = checkbox.value;
      if (checkbox.checked) {
        this.selectedOtherDiseases.push(id);
      } else {
        this.selectedOtherDiseases = this.selectedOtherDiseases.filter(
          (selectedId) => selectedId !== id
        );
        this.selectedOtherDiseasesIds = this.selectedOtherDiseasesIds.filter(
          (selectedId) => selectedId !== id
        );
      }
    } else if (type === 'medications') {
      const checkbox = event.target as HTMLInputElement;
      const id = checkbox.value;
      if (checkbox.checked) {
        this.selectedMedications.push(id);
      } else {
        this.selectedMedications = this.selectedMedications.filter(
          (selectedId) => selectedId !== id
        );
        this.selectedMedicationsIds = this.selectedMedicationsIds.filter(
          (selectedId) => selectedId !== id
        );
      }
    }
  }

  // Submit
  saveAndTakePicture(e: Event) {
    e.preventDefault();
    this.savePatientInformationForm();

    const generalComplaintsObject = {
      itching: false,
      pain: false,
      bleeding: false,
      ulceration: false,
    };

    const changeObject = {
      hasSizeChange: false,
      hasGreaterThan6mmChange: false,
      hasBorderChange: false,
      hasColorChange: false,
    };

    const sinceObject = {
      hasCongenital: false,
      customCongenitalValue: null,
    };

    const lesionCharacteristic = {
      ...generalComplaintsObject,
      ...sinceObject,
      ...changeObject,
    };

    const form: any = {
      ...this.patientInformationObject,
      patientId: this.patientId || this.workListPatientId,
      riskFactors: [...new Set([...this.selectedRiskFactorIds, ...this.selectedRiskFactors])],
      dermatologicDiseases: [...new Set([...this.selectedDermatologicDiseasesIds, ...this.selectedDermatologicDiseases])],
      neoplasticDiseases: [...new Set([...this.selectedNeoplasticDiseasesIds, ...this.selectedNeoplasticDiseases])],
      diseaseCousingImmunosuppressions: [...new Set([...this.selectedDiseaseCousingImmunosuppressionsIds, ...this.selectedDiseasesCausingImmunosuppression])],
      otherDiseases: [...new Set([...this.selectedOtherDiseasesIds, ...this.selectedOtherDiseases])],
      medications: [...new Set([...this.selectedMedicationsIds, ...this.selectedMedications])],
      lesionCharacteristic: lesionCharacteristic,
    };

    if (this.caseId) {
      form.relatedPatientRecordCaseId = this.caseId;
    }

    if (this.isAppointmentPatient) {
      form.isAppointmentPatient = this.isAppointmentPatient;
      form.appointmentId = this.appointmentId;
    }

    this.patientsService.saveAndTakeImage(form).subscribe({
      next: async (res) => {
        this.openWaitingModal();
        this.showSaveAndTakePicture = false;
        this.takeImageAgainBtn = false;
        this.createPatientRecordWithQrCode(res.id);
        this.interval = setInterval(() => {
          this.getPatientRecordCaseImages(res?.id);
        }, 5000);

        this.toastService.showToast(
          this.translate.instant('successSaveAndTakePictureDesc'),
          'success'
        );
      },
    });
  }

  selectItem(index: number, selectItem: any): void {
    this.caseImages = [];
    this.selectedIndex = index;
    this.selectedTimelineCaseId = selectItem.patientRecordCaseId;
    this.getPatientRecordCaseDetail(selectItem.patientRecordCaseId);
    this.getPatientRecordCaseImages(selectItem.patientRecordCaseId);
    this.getConsultationDetail(selectItem.patientRecordCaseId, 'timeline');

    this.interval = setInterval(() => {
      this.getPatientRecordCaseImages(selectItem.patientRecordCaseId);
    }, 5000);

    if (this.caseDetailHeader?.patientStatus > 2) {
      this.saveAndTakeCaseForm.disable();
      this.isFormElementsEnabled = true;
    }

    if (selectItem.isToday) {
      this.isCaseToday = selectItem.isToday;
      this.saveAndTakeCaseForm.enable();
      this.isFormElementsEnabled = false;
      this.saveAndTakeCaseForm.reset();
    } else {
      this.saveAndTakeCaseForm.disable();
      this.isFormElementsEnabled = true;
      this.isCaseToday = '';
    }
  }

  getStatusClass(status: number): string {
    return StatusUtils?.getCaseStatusClass(status);
  }

  getStatusText(status: number): string {
    return StatusUtils?.getCaseStatusText(status);
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.saveAndTakeCaseForm.get(controlName);
    return control ? control.invalid && control.touched : false;
  }

  async takePictureAgain() {
    const json = {
      patientRecordCaseId: this.caseId,
    };

    this.patientsService.photoAgain(json).subscribe({
      next: async () => {
        this.toastService.showToast(
          this.translate.instant(
            'Taking image again process completed successfully'
          ),
          'success'
        );
      },
    });
  }

  openWaitingModal() {
    if (this.waitingModalModal) {
      this.renderer2.setStyle(
        this.waitingModalModal.nativeElement,
        'display',
        'block'
      );
      this.renderer2.addClass(this.waitingModalModal.nativeElement, 'show');

      this.backdropElement = this.renderer2.createElement('div');
      this.renderer2.addClass(this.backdropElement, 'modal-backdrop');
      this.renderer2.addClass(this.backdropElement, 'fade');
      this.renderer2.addClass(this.backdropElement, 'show');
      this.renderer2.appendChild(document.body, this.backdropElement);
    }
  }

  closeWaitingModal() {
    if (this.waitingModalModal) {
      this.renderer2.setStyle(
        this.waitingModalModal.nativeElement,
        'display',
        'none'
      );
      this.renderer2.removeClass(this.waitingModalModal.nativeElement, 'show');

      if (this.backdropElement) {
        this.renderer2.removeChild(document.body, this.backdropElement);
        this.backdropElement = null;
      }
    }
  }

  get isButtonActive(): boolean {
    return this.selectedImage != null ? true : false;
  }

  getSelectedImage(): any {
    this.selectedImage =
      this.caseImages.find((image) => image.isSelected) || null;
    return this.selectedImage;
  }

  onMedicationSelect(event: any) {
    const medicationValues = event?.value;
    this.medications = [...new Set(this.medications)];
  }

  goToOtherTab(type: string) {
    if (type === 'patient-information-content') {
      this.showSaveAndTakePictureButton = true;
      const tabLinks = document.querySelectorAll('.nav-link');
      const tabPanes = document.querySelectorAll('.tab-pane');

      tabLinks.forEach((link) => link.classList.remove('active'));
      tabPanes.forEach((pane) => pane.classList.remove('show', 'active'));
      const patientInformationTabLink = document.querySelector(
        '[href="#patient-information-content"]'
      );
      const patientInformationTabPane = document.querySelector(
        '#patient-information-content'
      );

      if (patientInformationTabLink && patientInformationTabPane) {
        patientInformationTabLink.classList.add('active');
        patientInformationTabPane.classList.add('show', 'active');
      }
    } else if (type === 'medical-history') {
      if (this.patientInformationForm.valid) {
        const tabLinks = document.querySelectorAll('.nav-link');
        const tabPanes = document.querySelectorAll('.tab-pane');

        tabLinks.forEach((link) => link.classList.remove('active'));
        tabPanes.forEach((pane) => pane.classList.remove('show', 'active'));
        const medicalHistoryTabLink = document.querySelector(
          '[href="#medical-history"]'
        );
        const medicalHistoryTabPane =
          document.querySelector('#medical-history');

        if (medicalHistoryTabLink && medicalHistoryTabPane) {
          medicalHistoryTabLink.classList.add('active');
          medicalHistoryTabPane.classList.add('show', 'active');
        }
      } else {
        this.toastService.showToast(
          this.translate.instant('All required fields must be filled!'),
          'warning'
        );

        this.patientInformationForm.markAllAsTouched();
      }
    } else if (type === 'medications') {
      this.showSaveAndTakePictureButton = false;
      const tabLinks = document.querySelectorAll('.nav-link');
      const tabPanes = document.querySelectorAll('.tab-pane');

      tabLinks.forEach((link) => link.classList.remove('active'));
      tabPanes.forEach((pane) => pane.classList.remove('show', 'active'));
      const medicalHistoryTabLink = document.querySelector(
        '[href="#medications"]'
      );
      const medicalHistoryTabPane = document.querySelector('#medications');

      if (medicalHistoryTabLink && medicalHistoryTabPane) {
        medicalHistoryTabLink.classList.add('active');
        medicalHistoryTabPane.classList.add('show', 'active');
      }
    }
  }

  isSaveButtonDisable() {
    return !(
      this.patientInformationForm.valid && !this.showSaveAndTakePictureButton
    );
  }

  generalAppearanceTextHeader(): any {
    let generalAppearanceText: string = '';

    if (this.patientCaseCardInformation?.generalAppearance?.freckles) {
      generalAppearanceText += this.translate.instant('freckles') + ',';
    }
    if (this.patientCaseCardInformation?.generalAppearance?.redHair) {
      generalAppearanceText += this.translate.instant('redHair') + ',';
    }
    if (this.patientCaseCardInformation?.generalAppearance?.lightColoredEyes) {
      generalAppearanceText += this.translate.instant('lightColoredEyes') + ',';
    }
    if (generalAppearanceText.endsWith(',')) {
      generalAppearanceText = generalAppearanceText.slice(0, -1);
    }
    return generalAppearanceText;
  }

  skinTypeTextHeader(): string {
    const typeText = this.translate.instant('type');
    switch (this.patientCaseCardInformation?.skinType) {
      case SkinTypes.Type1:
        return `${typeText} 1 `;

      case SkinTypes.Type2:
        return `${typeText} 2 `;

      case SkinTypes.Type3:
        return `${typeText} 3 `;

      case SkinTypes.Type4:
        return `${typeText} 4 `;

      case SkinTypes.Type5:
        return `${typeText} 5 `;

      case SkinTypes.Type6:
        return `${typeText} 6 `;

      default:
        return '';
    }
  }

  setInputAfterBlur(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const val = Number(inputElement.value);
    if (isNaN(val) || val < 1) {
      inputElement.value = '1';
      return;
    }
  }

  onDateInputChange(value: string): void {
    const sanitizedValue = value.replace(/[^0-9]/g, '');
    const today = new Date();
    let formattedValue = '';

    if (sanitizedValue.length <= 2) {
      formattedValue = sanitizedValue;
    } else if (sanitizedValue.length <= 4) {
      formattedValue = `${sanitizedValue.slice(0, 2)}-${sanitizedValue.slice(
        2
      )}`;
    } else if (sanitizedValue.length <= 8) {
      formattedValue = `${sanitizedValue.slice(0, 2)}-${sanitizedValue.slice(
        2,
        4
      )}-${sanitizedValue.slice(4)}`;
    }

    const [day, month, year] = formattedValue
      .split('-')
      .map((part) => parseInt(part, 10));

    const currentYear = new Date().getFullYear();
    const minYear = currentYear - 145;
    if (
      formattedValue.startsWith('00') ||
      formattedValue.substring(3, 5) === '00' ||
      formattedValue.substring(6, 7) === '0' ||
      (day && day > 31) ||
      (month && month > 12) ||
      (year &&
        year.toString().length == 4 &&
        (year > currentYear || year < minYear))
    ) {
      this.patientInformationForm.patchValue({
        birthDate: '',
      });
      return;
    }

    const inputDate = new Date(year, month - 1, day);

    const todayFormatted = `${today.getDate().toString().padStart(2, '0')}-${(
      today.getMonth() + 1
    )
      .toString()
      .padStart(2, '0')}-${today.getFullYear()}`;

    if (sanitizedValue.length === 8 && inputDate > today) {
      this.patientInformationForm.patchValue({
        birthDate: todayFormatted,
      });
    } else {
      this.patientInformationForm.patchValue({
        birthDate: formattedValue,
      });
    }
  }

  onBlurDateInput(event) {
    const date = this.patientInformationForm.get('birthDate').value;
    if (date?.length === 10) {
      const caseDetail = { age: 0, birthDate: date };
      const newAge = this.getAge(caseDetail);
      this.caseDetailHeader.age = newAge;
    }
  }

  formatDate2(dateString: string): string {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  checkNameLastnameBirthDateExists() {
    const name = this.patientInformationForm.get('name')?.value;
    const lastName = this.patientInformationForm.get('lastName')?.value;
    const birthDate = this.formatBirthDateService.formatBirthDate(
      this.patientInformationForm.get('birthDate')?.value
    );
    if (!name || !lastName || !birthDate) return;
    const params = {
      name,
      lastName,
      birthDate,
    };
    this.patientsService.getPatientByNameAndBirthDate(params).subscribe({
      next: (res) => {
        if (res?.result && res?.birthDate && res?.nameLastName) {
          this.openNameLastnameBirthDateValidationErrorModal();
        }
      },
    });
  }

  openNameLastnameBirthDateValidationErrorModal() {
    if (this.nameLastnameBirthDateValidationErrorModal) {
      this.renderer2.setStyle(
        this.nameLastnameBirthDateValidationErrorModal.nativeElement,
        'display',
        'block'
      );
      this.renderer2.addClass(
        this.nameLastnameBirthDateValidationErrorModal.nativeElement,
        'show'
      );
      this.backdropElement = this.renderer2.createElement('div');
      this.renderer2.addClass(this.backdropElement, 'modal-backdrop');
      this.renderer2.addClass(this.backdropElement, 'fade');
      this.renderer2.addClass(this.backdropElement, 'show');
      this.renderer2.appendChild(document.body, this.backdropElement);
    }
  }

  closeNameLastnameBirthDateValidationErrorModal(type: 'yes' | 'no') {
    if (type === 'no') {
      this.patientInformationForm.get('name')?.setValue('');
      this.patientInformationForm.get('lastName')?.setValue('');
      this.patientInformationForm.get('birthDate')?.setValue('');
    }

    if (this.nameLastnameBirthDateValidationErrorModal) {
      this.renderer2.setStyle(
        this.nameLastnameBirthDateValidationErrorModal.nativeElement,
        'display',
        'none'
      );
      this.renderer2.removeClass(
        this.nameLastnameBirthDateValidationErrorModal.nativeElement,
        'show'
      );
      if (this.backdropElement) {
        this.renderer2.removeChild(document.body, this.backdropElement);
        this.backdropElement = null;
      }
    }
  }

  preventForbiddenCharacters(
    event: Event,
    type: 'number' | 'text' | 'email' | 'tel'
  ): void {
    this.inputValidationService.preventForbiddenCharacters(event, type);
  }

  formatBirthDate(dateString: string): string {
    const datePattern = /^\d{2}-\d{2}-\d{4}$/;

    if (!datePattern.test(dateString)) {
      return dateString;
    }

    const [day, month, year] = dateString.split('-').map(Number);

    if (month < 1 || month > 12) {
      return dateString;
    }

    const daysInMonth = new Date(year, month, 0).getDate();
    if (day < 1 || day > daysInMonth) {
      return dateString;
    }

    const date = new Date(Date.UTC(year, month - 1, day));

    return date.toISOString();
  }
}
